import { useState } from "react";
import { Button } from "@fluentui/react-components";
import { ArrowSwap24Regular } from "@fluentui/react-icons";
import { TeamsProvider, useHost } from "./teams/TeamsProvider";
import { DataProvider, useData } from "./data/DataProvider";
import { useRoute } from "./lib/nav";
import { ConfigPage } from "./pages/ConfigPage";
import { NonAutorizzato } from "./pages/NonAutorizzato";
import { MieRichieste } from "./pages/richiedente/MieRichieste";
import { NuovaRichiesta } from "./pages/richiedente/NuovaRichiesta";
import { Inviata } from "./pages/richiedente/Inviata";
import { DettaglioRichiedente } from "./pages/richiedente/DettaglioRichiedente";
import { Coda } from "./pages/gestore/Coda";
import { GestisciRichiesta } from "./pages/gestore/GestisciRichiesta";

/**
 * Punti di ingresso (percorso dell'URL):
 *   /config → configurazione della scheda di canale
 *   /tab    → scheda di canale (pensata per i gestori)
 *   /app    → app personale (pensata per i coordinatori)
 *   /       → come /app (sviluppo nel browser)
 */
export function App() {
  const path = window.location.pathname.replace(/\/$/, "");
  return (
    <TeamsProvider>
      {path === "/config" ? (
        <ConfigPage />
      ) : (
        <DataProvider>
          <Router />
        </DataProvider>
      )}
    </TeamsProvider>
  );
}

type Vista = "richiedente" | "gestore";

function Router() {
  const { roles } = useData();
  const { inChannel } = useHost();
  const route = useRoute();
  const path = window.location.pathname.replace(/\/$/, "");
  const preferita: Vista = path === "/tab" || inChannel ? "gestore" : "richiedente";
  const [vista, setVista] = useState<Vista>(() =>
    preferita === "gestore" ? (roles.gestore ? "gestore" : "richiedente") : roles.coordinatore ? "richiedente" : "gestore",
  );

  if (!roles.gestore && !roles.coordinatore) return <NonAutorizzato />;

  // Chi ha entrambi i ruoli può passare da una vista all'altra
  const switcher =
    roles.gestore && roles.coordinatore ? (
      <Button
        appearance="subtle"
        icon={<ArrowSwap24Regular />}
        aria-label={vista === "gestore" ? "Passa a le tue richieste" : "Passa alla vista gestore"}
        title={vista === "gestore" ? "Le tue richieste" : "Vista gestore"}
        onClick={() => setVista(vista === "gestore" ? "richiedente" : "gestore")}
      />
    ) : undefined;

  if (vista === "gestore") {
    if (route.name === "dettaglio") return <GestisciRichiesta id={route.id} />;
    return <Coda switcher={switcher} />;
  }
  switch (route.name) {
    case "nuova":
      return <NuovaRichiesta />;
    case "inviata":
      return <Inviata id={route.id} fotoNonCaricate={route.fotoNonCaricate} />;
    case "dettaglio":
      return <DettaglioRichiedente id={route.id} />;
    default:
      return <MieRichieste switcher={switcher} />;
  }
}
